<template>
  <div class="introduction-box">
    <transition name="introduction-demo">
      <div class="introduction-demo-area" v-show="isaActivated">
        <div class="introduction-title">KauKauモール</div>
        <ul>
          <li
            class="introduction-list"
            v-for="(n, index) in introductionList"
            :key="index"
            v-html="n"
          ></li>
        </ul>
        <ul>
          <li
            class="introduction-list"
            v-for="(n, index) in introductionList2"
            :key="index"
            v-html="n"
          ></li>
        </ul>
				<br/>
        <p class="introduction-list">
          ご決済には、日本のクレジットカードも使えて便利です！
        </p>
        <div class="introduction-title2">購入代行</div>
        <div class="introduction-list1">
          お酒類、食品、日用品、電化製品など、ご自分で探すことが難しい<br />
          個性ある商品の購入をNanacoが代行します。<br />
          複数のECプラットフォームで探していた商品を、Nanacoが<br />
          ワンストップで行うことで、みなさまのニーズにお応えします。
        </div>
      </div>
    </transition>
    <div class="introduction-image">
      <img :src="partsImage" v-show="isaActivated" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      introductionList: [
        "特選ストアが集う「KauKauモール」は、日本語環境でショッピ",
        "ングが楽しめる“ネット特選街”です。"
      ],
      introductionList2: [
        "中国在住の日本人が欲しいと感じるツボを押さえた品揃えを",
        "モットーに、タイムリーな配達を保証。"
      ],
      shadow: "box-shadow:0px 0px 108px 0px rgba(238,178,94,0.18);",
      partsImage: null,
      isaActivated: false
    };
  },
  methods: {
    init(partsImage) {
			console.log('partsImage =>', partsImage);
      this.isaActivated = true;
      this.partsImage = partsImage;
      return this.shadow;
    },
    back() {
      this.isaActivated = false;
    }
  }
};
</script>
<style scoped>
.introduction-box {
  width: 100%;
  height: 100%;
  justify-content: space-around;
  display: flex;
  background-color: white;
}
.introduction-image {
  width: 2rem;
}
.introduction-demo-area {
  width: 6.8rem;
  padding-top: 1rem;

  height: 100%;

  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.introduction-demo-area ul {
  margin-top: 0.2rem;
}
.introduction-title {
  font-size: 0.6rem;
  font-weight: bold;
  text-indent: -0.1rem;
  color: #50391e;
}
.introduction-title2 {
  padding-top: 0.2rem;
  font-size: 0.45rem;
  font-weight: bold;
  text-indent: -0.1rem;
  color: #50391e;
}
.introduction-title3 {
  padding-top: 0.2rem;
  font-size: 0.15rem;
  font-weight: bold;
  text-indent: 0.1rem;
  color: #50391e;
}
.introduction-list {
  font-size: 0.2rem;
  font-weight: normal;

  color: #50391e;
  /* width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  position: relative;
  font-size: 18px;
  line-height: 35px;
  margin-top: 20px;
  font-weight: bold;
  color: #000;
  display: list-item; */
}
.introduction-list1 {
  margin-top: 0.2rem;
  font-size: 0.2rem;
  color: #50391e;
}
.introduction-image {
  width: 5rem;
}
.introduction-image img {
  width: 100%;
  height: auto;
  padding-top: 1rem;
}
.introduction-demo-enter-active,
.introduction-demo-leave-active {
  transition: all 0.5s;
}
.introduction-demo-enter, .introduction-demo-leave-to /* .fade-leave-active below version 2.1.8 */ {
  right: -6.5rem;
}
.food-bottom-icons {
  display: block;
  margin: 0 auto;
  width: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/modules/round-spare-parts/mall.vue